import gql from 'graphql-tag';

export default gql`
  query priceByQty($input: ItemPriceInput) {
    priceByQty(input: $input)
  }
`;
